import React, { useState, useEffect, useRef } from 'react'
import { Table } from 'react-bootstrap'
import { Formik } from 'formik'
import useDebounce from '../../../lib/useDebounce'
import Select from 'react-select'
import axiosProvider from '../../../lib/AxiosProvider'
import Loader from '../../../components/Loader'
import { customStyles } from '../../../components/customStyles'
import CustomToast from '../../../components/Toast/CustomToast'
import IpCheckbox from '../../../components/IpCheckbox'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { _SwalDelete } from '../../../lib/exceptionMessage'

const RoleTypeWise = (props) => {
  const [initialdata, setInnitialData] = useState(true)
  const [searchText, setSearchText] = useState()
  const [data, setData] = useState()
  const [filteredData, setFilteredData] = useState()
  const [modalShow, setModalShow] = useState(false)
  const [dropDownData, setDropDownData] = useState()
  const [secondDropDownData, setSecondDropDownData] = useState([])
  const [pageEntries, setPageEntries] = useState(10)
  const [onClickPage, setOnClickPage] = useState(1)
  const [pageCount, setPageCount] = useState(1)
  const [filteredPageCount, setFilteredPageCount] = useState(1)
  const [loading, setLoading] = useState(false)
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const ref = useRef()

  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()

  useEffect(() => {
    clearController()
  }, [secondDropDownData])

  const clearController = () => {
    if (!secondDropDownData?.length) {
      ref?.current?.clearValue()
    }
  }

  useEffect(() => {
    fetchDropDownData()
  }, [pageEntries, onClickPage])

  useEffect(() => {
    if (modalShow === false) {
      setInnitialData(true)
    }
  }, [modalShow])

  const fetchData = async (id, setFieldValue) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'PageModule',
      queryString: `?pageSize=0&pageIndex=0`
    })
      .then(async (res) => {
        if (res.status === 200 && res.data.data.length > 0) {
          let pageModuleArray = res?.data?.data
          let unionArr = res?.data?.data
          const api = await axiosProvider({
            method: 'GET',
            endpoint: 'AssignPageRolesByRoleType',
            queryString: `?Id=${id}`
          }).then((res) => {
            if (res?.status === 200 && res?.data?.data.length > 0) {
              let pageModuleIdArray = res?.data?.data
              unionArr = pageModuleIdArray.concat(
                pageModuleArray.filter(
                  (obj2) =>
                    !pageModuleIdArray.find(
                      (obj1) => obj1.pageRoleId === obj2.id
                    )
                )
              )
            }
          })
          setFieldValue('pageRoleData', unionArr)
          setData(res)
          setFilteredData(res)
          setPageCount(res.data?.pagination?.pageCount)
          setFilteredPageCount(res.data?.pagination?.pageCount)
        } else {
          setPageCount(0)
          setFilteredPageCount(0)
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const debounceSearchText = useDebounce(searchText, 500)

  useEffect(() => {
    if (debounceSearchText) {
      fetchSearchData()
    } else {
      setFilteredData(data)
      setFilteredPageCount(pageCount)
    }
  }, [debounceSearchText])

  const fetchSearchData = async () => {
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'City/Search',
      queryString: `?name=${debounceSearchText}`
      //      headers: {
      //     'Access-Control-Allow-Origin': '*',
      // }
    })
      .then((res) => {
        if (res?.status === 200 && res?.data?.data?.length > 0) {
          setFilteredData(res)
          setFilteredPageCount(res.data?.data[0].pageCount)
        } else if (res?.data?.code === 204) {
          setFilteredData(res)
          setFilteredPageCount(0)
        } else {
          setFilteredPageCount(0)
        }
      })
      .catch((err) => {})
  }

  const fetchDropDownData = async () => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'GetAllRoleTypes',
      queryString: `?pageindex=0&PageSize=0`
      //      headers: {
      //     'Access-Control-Allow-Origin': '*',
      // }
    })
      .then((res) => {
        if (res.status === 200 && res.data.data.length > 0) {
          setDropDownData(res?.data)
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const changeRight = async (data, setFieldValue, pageModuleArray) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'POST',
      endpoint: `AssignPageRoles`,
      data,
      userId,
      location: location.pathname
    })
      .then((res) => {
        if (res?.status === 200) {
          let pageModule = pageModuleArray?.map((page) => {
            if (page?.pageRoleId === data?.pageRoleId) {
              return data
            } else {
              return page
            }
          })
          setFieldValue('pageRoleData', pageModule)
        }
        setLoading(false)
        setToast({
          show: true,
          text: res?.data?.message,
          variation: res?.data?.code !== 200 ? 'error' : 'success'
        })

        setTimeout(() => {
          setToast({ ...toast, show: false })
        }, 2000)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const initValForTable = {}

  return (
    <>
      <Formik initialValues={initValForTable}>
        {({ values, setFieldValue }) => (
          <>
            <div className='d-flex align-items-center mb-3 gap-3'>
              <div className='input-select-wrapper flex-fill'>
                <label className='form-label'>Select Role Type</label>
                <Select
                  id='countryID'
                  menuPortalTarget={document.body}
                  menuPosition={'fixed'}
                  styles={customStyles}
                  isDisabled={!initialdata ? true : false}
                  options={dropDownData?.data
                    ?.filter((item) => item?.name !== 'Super Admin')
                    ?.map(({ id, name }) => ({
                      value: id,
                      label: name
                    }))}
                  onChange={(e) => {
                    if (e) {
                      fetchData(e?.value, setFieldValue)
                      setFieldValue('roleTypeId', e?.value)
                    }
                  }}
                />
              </div>
              {/* <Button
          variant='warning'
          className='d-flex align-items-center gap-2 fw-semibold'
          onClick={() => {
            !dropDownData && fetchDropDownData()
            setModalShow(true)
          }}
        >
          <i className='m-icon m-icon--plusblack'></i>
          Create
        </Button> */}
            </div>

            {values?.pageRoleData?.length > 0 && (
              <Table responsive className='align-middle table-list'>
                <thead>
                  <tr>
                    <th>Page Name</th>
                    <th className='text-center'>Select All</th>
                    <th className='text-center'>View</th>
                    <th className='text-center'>Add</th>
                    <th className='text-center'>Edit</th>
                    <th className='text-center'>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {values?.pageRoleData?.map((data, index) => (
                    <tr key={Math.floor(Math.random() * 1000000)}>
                      <td>
                        {data?.pageRoleId ? data?.pageRoleName : data?.name}
                      </td>
                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='read'
                          checked={
                            data?.read &&
                            data?.add &&
                            data?.delete &&
                            data?.update
                              ? true
                              : false
                          }
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  read: e?.checked,
                                  add: e?.checked,
                                  delete: e?.checked,
                                  update: e?.checked,
                                  selectAll: e?.checked
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  pageRoleName: data?.name,
                                  read: e?.checked,
                                  add: e?.checked,
                                  delete: e?.checked,
                                  udpate: e?.checked,
                                  selectAll: e?.checked
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='read'
                          checked={data?.read ? true : false}
                          changeListener={(e) => {
                            if (data?.add || data?.update || data?.delete) {
                              if (!e?.checked) {
                                Swal.fire({
                                  title: 'Cannot Remove View Permission!',
                                  text: `Cannot Remove View Permission: Other permissions ${
                                    data?.add ? 'Create' : ''
                                  } ${data?.update ? 'Update' : ''} ${
                                    data?.delete ? 'Delete' : ''
                                  } already granted.`,
                                  icon: _SwalDelete.icon,
                                  showCancelButton:
                                    _SwalDelete.showCancelButton,
                                  confirmButtonColor:
                                    _SwalDelete.confirmButtonColor,
                                  cancelButtonColor:
                                    _SwalDelete.cancelButtonColor,
                                  confirmButtonText: 'Yes',
                                  cancelButtonText: _SwalDelete.cancelButtonText
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    let tempData = data?.pageRoleId
                                      ? {
                                          ...data,
                                          read: e?.checked,
                                          add: false,
                                          delete: false,
                                          update: false
                                        }
                                      : {
                                          pageRoleId: data?.id,
                                          roleTypeId: values?.roleTypeId,
                                          pageRoleName: data?.name,
                                          read: e?.checked,
                                          add: false,
                                          delete: false,
                                          udpate: false
                                        }
                                    changeRight(
                                      tempData,
                                      setFieldValue,
                                      values?.pageRoleData
                                    )
                                  } else if (result.isDenied) {
                                  }
                                })
                              } else {
                                let tempData = data?.pageRoleId
                                  ? {
                                      ...data,
                                      read: e?.checked
                                    }
                                  : {
                                      pageRoleId: data?.id,
                                      roleTypeId: values?.roleTypeId,
                                      pageRoleName: data?.name,
                                      read: e?.checked,
                                      add: false,
                                      delete: false,
                                      udpate: false
                                    }
                                changeRight(
                                  tempData,
                                  setFieldValue,
                                  values?.pageRoleData
                                )
                              }
                            } else {
                              let tempData = data?.pageRoleId
                                ? {
                                    ...data,
                                    read: e?.checked
                                  }
                                : {
                                    pageRoleId: data?.id,
                                    roleTypeId: values?.roleTypeId,
                                    pageRoleName: data?.name,
                                    read: e?.checked,
                                    add: false,
                                    delete: false,
                                    udpate: false
                                  }
                              changeRight(
                                tempData,
                                setFieldValue,
                                values?.pageRoleData
                              )
                            }
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='add'
                          checked={data?.add ? true : false}
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  add: e?.checked,
                                  read: data?.read ? data?.read : e?.checked
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  add: e?.checked,
                                  read: e?.checked,
                                  delete: false,
                                  udpate: false
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='update'
                          checked={data?.update ? true : false}
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  update: e?.checked,
                                  read: data?.read ? data?.read : e?.checked
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  update: e?.checked,
                                  add: false,
                                  delete: false,
                                  read: e?.checked
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          checked={data?.delete ? true : false}
                          value='delete'
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  delete: e?.checked,
                                  read: data?.read ? data?.read : e?.checked
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  delete: e?.checked,
                                  add: false,
                                  read: e?.checked,
                                  udpate: false
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
      </Formik>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && !modalShow && <Loader />}
    </>
  )
}

export default RoleTypeWise
